import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface SignUpConfirmModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  email?: string;
}

const SignUpConfirmModal = ({
  isOpen = false,
  onClose,
  email = ''
}: SignUpConfirmModalProps) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="md"
    >
      <ModalContent className="p-6 max-w-md">
        <ModalHeader className="flex justify-between items-start">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">
            ¡Registro exitoso!
          </h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </ModalHeader>
        
        <ModalBody>
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            
            <p className="text-gray-700 dark:text-gray-300 mb-2">
              Hemos enviado un correo de confirmación a:
            </p>
            <p className="font-semibold text-gray-900 dark:text-white mb-4">
              {email}
            </p>
            
            <p className="text-gray-600 dark:text-gray-400">
              Por favor revisa tu buzón principal o correo no deseado y haz clic en el enlace de validación de cuenta.
            </p>
          </div>
        </ModalBody>
        
        <ModalFooter className="flex justify-center">
          <Button 
            color="primary" 
            variant="solid" 
            className="px-6"
            onPress={onClose}
          >
            Entendido
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SignUpConfirmModal;